<template>
  <div v-if="clientMessage"
       class="mr-auto p-0"
       :class="customClass"
       :title="titleText">

    <div class="multiline-clamp"
         :class="important ? 'h3' : 'text-small'"
         :style="{ '-webkit-line-clamp': clampLines }">
      <span class="mr-1" :class="clientMessage.msgIconClass"></span>
      <span v-text="displayText"></span>
    </div>

  </div>
</template>

<script>
import { isValid } from "../../../utils/utilitiesmodule";
export default {

	name: "ClientMessageView",
	props: {
		commands: {
			type: Array,
		},
		important: {
			type: Boolean,
			required: false,
			default: false
		},
		width: {
			type: Number,
			required: false,
			default: 50
		},
		clampLines: {
			type: [Number, String],
			default: 2
		},
		inDialogActions: {
			type: Boolean,
			default: true
		} // quante righe mostrare

	},
	data() {
		return {
			clientMessage: null,
			titleText: "",
			displayText: "",
			customClass: ""
		}
	},

	created() {
		this.commands?.forEach(m => {

			this.$root.$on("sendClientMessage_"+m.toUpperCase(), clientMessage => {
				this.setClientMessage(clientMessage)
			});
		})

	},

	methods: {
		setClientMessage(clientMessage) {
			if (!clientMessage||!isValid(clientMessage.text)) {
				clientMessage=null;
				this.titleText="";
				this.displayText="";
			} else {
				this.titleText=clientMessage.isTranslated
					? (clientMessage.text||'')
					:this.$t(clientMessage.text, clientMessage.msgArgs)||'';

				this.displayText=this.titleText.replace(/\\n/g, '\n');

				console.debug(clientMessage);
				this.customClass=clientMessage.textColor;
				if (this.inDialogActions) {
					this.customClass+=' w-'+this.width;
				}
			}

			this.clientMessage=clientMessage;
		}
	},
	beforeDestroy() {
		this.commands?.forEach(m => {
			this.$root.$off("sendClientMessage_"+m.toUpperCase());
		});
	}
}
</script>